module.exports = __webpack_public_path__ + "img/clock-icon.cd228223.svg";